import { formatConfidenceFilter, checkPermissions } from 'react/utils/utils';

Greenmile.MassiveSmartGeocode = Greenmile.MassiveSmartGeocode || {};

Greenmile.MassiveSmartGeocode.Grid = function () {

    const entity = 'MassiveSmartGeocode';

    const formatterColumns = function (row, cell, value, column, dataContext) {

        let id;

        if (value) {

            if (column.field === "locationsDistance") {
                value = new Monet.Format.DISTANCE(value).toGrid().getValue();
            }

            if (column.field === "location.geocodingDate" || column.field === "location.geocodingLastCheck") {
                value = Monet.Format.Date.formatToLocale(value);
            }

            if (column.field === "confidence") {
                value = (value * 100).toFixed(2) + '%';
            }

            if (column.field === "proposedLat" || column.field === "proposedLong") {
                value = value.toString().substring(0, 12);
            }

        }

        if (column.field === "seeOnMap") {
            id = dataContext.model.get('location').id;
            value = '<div class="iconMap" onclick="App.Views.MassiveSmartGeocode.showMap(' + id + ')"></div>';
        }

        if (column.field === "editLocation") {
            id = dataContext.model.get('location').id;
            value = '<a class="table-action-editlink" href="#/Location/edit/' + id + '"></a>';
        }

        return value;
    };

    const getTitleToMathDistanceAverage = function () {
        const unitySystemMetric = new Greenmile.Calculos.GeneralFunctions().getUnitSystemToColumnGrid();
        return " (" + unitySystemMetric + ")";
    };

    const renderFilterBuilder = function(router) {
        let filterBuilder = App.Forms.MassiveSmartGeocode.filterBuilder;
        const defaultFilters = {
            'confidence_Range': {
                ini: '',
                fin: ''
            },
        };

        if(!filterBuilder) {
            filterBuilder = new Monet.UI.FilterBuilder();
            filterBuilder.setIdScreen('SmartGeocode');
            filterBuilder.setEntity('MassiveSmartGeocode');
            filterBuilder.setCustomNameSpace('MassiveSmartGeocode');
            filterBuilder.setProjection(router.getProjection());
            filterBuilder.setDefaultFilters(defaultFilters);
            filterBuilder.setcustomAdjustHeaderSize(router.adjustHeaderSize)
            filterBuilder.customRequest = (filter) => {
              const formattedFilters = formatConfidenceFilter(filter);

              router.getSmartGeocodes(
                formattedFilters,
                Monet.Grid.addDataToGrid,
                App.Forms.MassiveSmartGeocode.pagination.first > 0
              );
            };

            App.Forms.MassiveSmartGeocode.filterBuilder = filterBuilder;
        }

        filterBuilder.render();

        const gridActions = document.querySelector('#SmartGeocode .gridActions .actions');
        gridActions.appendChild(filterBuilder.el);

        const confidenceRangeFields = document.querySelectorAll(
          '#MassiveSmartGeocode_confidence_Range > input.decimalFieldOld'
        );

        confidenceRangeFields.forEach((field) => {
          field.style.backgroundImage =
            "url('/static/images/fields/percent_field.svg')";
        });

        const confidenceField = document.querySelector(
          '#MassiveSmartGeocode_confidence > input.decimalFieldOld'
        );

        if (confidenceField) {
          confidenceField.style.backgroundImage =
            "url('/static/images/fields/percent_field.svg')";
        }
    };

    this.getColumns = async function () {

        const mapColumn = {
            id: "seeOnMap",
            cssClass: "cell-row",
            defaultSortAsc: true,
            entity,
            field: "seeOnMap",
            name: Monet.I18n.getResourcesByKey("SmartGeocode.grid.map"),
            formatter: formatterColumns,
            width: 60,
            sortable: false,
            resizable: false,
            isFrozen: true
        };

        const editColumn = {
            id: "editLocation",
            cssClass: "cell-row",
            defaultSortAsc: true,
            entity,
            field: "editLocation",
            name: Monet.I18n.getResourcesByKey("SmartGeocode.grid.editLocation"),
            formatter: formatterColumns,
            width: 60,
            sortable: false,
            resizable: false,
            isFrozen: true
        };

        try {

            if (!App.Forms[entity].layout) {
                App.Forms[entity].layout = {};
            }

            let layout = App.Forms[entity].layout;

            if (!layout.index) {
                const router = new App.Routers.MassiveSmartGeocode();
                await router.getColumnsToGridLayout();

                layout = App.Forms[entity].layout;
            }

            const columns = Monet.Grid.getGridLayout(layout.index, entity);

            columns.forEach(column => {
                if (column.field === 'mathDistanceAverage') {
                    column.name += getTitleToMathDistanceAverage();
                }

                column.formatter = formatterColumns;
            });

            columns.unshift(mapColumn);
            if (checkPermissions('LOCATION_UPDATE')) {
              columns.unshift(editColumn);
            }

            return columns;

        } catch (e) {

            const error = new Monet.Exception.ReturnError(this, 'Error getting columns for MassiveSmartGeocode', e);
            error.console();

        }



    };

    this.show = async function () {

        let error   = null,
            options = {
                entity,
                entityToActionGrid: entity,
                columnCheckBox: {
                    show: true,
                    checkBoxEventClass: [
                        Greenmile.MassiveSmartGeocode.AcceptAll,
                        Greenmile.MassiveSmartGeocode.AcceptSelected
                    ],
                    options: {
                        checkOnClickRow: true
                    }
                },
                columnEdit: {
                    show: false
                },
                frozenColumn: Monet.Grid.getIndexFrozenColumn(App.Forms.MassiveSmartGeocode.layout.index) + 2,
                gridContainner: '#gridSmartGeocode',
                multiColumnSort: true,
                selectorToGridActions: '#SmartGeocode .actions'
            },
            router;

        try {
            const columns = await this.getColumns();

            const exportFormats = new Monet.Grid.ActionsModules.ExportFormats();
            const customizeColumns = new Monet.Grid.ActionsModules.CustomizeColumns();
            const saveGridLayout = new Monet.Grid.ActionsModules.SaveGridLayout();
            const dataView = new Monet.Grid.DataProvider(columns, null, options.entity);
            const grid = new Monet.Grid.GenericGrid(options.gridContainner, dataView, columns, options);
            const selectorToActions = options.selectorToGridActions;

            exportFormats.setEntity(entity);
            exportFormats.setScreenName(entity);
            exportFormats.setSelector(selectorToActions);
            exportFormats.setElement(document.querySelector(selectorToActions));
            exportFormats.getDataBeforeExportFormats = () => {
              const data = {
                filterSort: [],
                filterCriteriaChain: { criteriaChain: [] },
                entityToRequest: entity,
              };

              const filterBuilder = App.Objects[entity].getFilter();
              const processIdFilter = {
                matchMode: "EXACT",
                attr: "processId",
                eq: Greenmile.MassiveSmartGeocode.currentProcessId
              };

              filterBuilder.criteriaChain[0].and.push(processIdFilter);

              data.filterSort = filterBuilder.sort;
              data.filterCriteriaChain = formatConfidenceFilter(filterBuilder);

              return data;
            };

            exportFormats.init();

            customizeColumns.setEntity(entity);
            customizeColumns.setScreenName(entity);
            customizeColumns.setSelector(selectorToActions);
            customizeColumns.setElement(document.querySelector(selectorToActions));
            customizeColumns.setCallBacks({
                afterSaveList: function () {
                    App.Views.MassiveSmartGeocode.showGrid();
                }
            });

            customizeColumns.init();

            saveGridLayout.setEntity(entity);
            saveGridLayout.setScreenName(entity);
            saveGridLayout.setSelector(selectorToActions);
            saveGridLayout.setElement(document.querySelector(selectorToActions));
            saveGridLayout.setCallBacks({
                afterSaveList: function () {
                    App.Views.MassiveSmartGeocode.showGrid();
                }
            });

            saveGridLayout.init();

            App.Forms.MassiveSmartGeocode.pagination.first = 0;

            router = App.Objects.MassiveSmartGeocode;

            renderFilterBuilder(router);

            router.adjustHeaderSize();

            const updateGrid = function () {
                router.updateGrid(router.getFilter(), Monet.Grid.addDataToGrid, App.Forms.MassiveSmartGeocode.pagination.first > 0);
            };

            updateGrid();

            App.Forms.MassiveSmartGeocode.table = grid;
            App.Forms.MassiveSmartGeocode.dataProvider = dataView;

            const acceptSelected = new Greenmile.MassiveSmartGeocode.AcceptSelected();
            const acceptAll = new Greenmile.MassiveSmartGeocode.AcceptAll();

            acceptAll.initialize(this.entity);
            acceptSelected.initialize(this.entity);

            if (Greenmile.MassiveSmartGeocode.isProcessingAccept) {
                App.Views.MassiveSmartGeocode.showLoadingAndDisableButtons();
            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this, 'Error on create grid smartgeocode', e);
            error.console();

        }

    };

};
